import { FormattedMessage, useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn } from 'ui-components/components/flex';

import { messages } from './messages';
import styles from './styles.module.css';
import { OVERWRITE_EXISTING_PACKAGES, type CustomPackageImportForm } from '../reducer';
import { AddCsvFile } from '../../../../../../components/csv-import/ui/components/add-csv-file';
import { useImportContext } from '../../../../../../components/csv-import/ui/components/import-context';
import { ImportDescription } from '../../../../../../components/csv-import/ui/components/import-description';
import { InitErrors } from '../../../../../../components/csv-import/ui/components/init-errors/init-errors';
import { MappingList } from '../../../../../../components/csv-import/ui/components/mapping-list/mapping-list';
import { StepHeader } from '../../../../../../components/csv-import/ui/components/step-header/step-header';
import { StepSuspense } from '../../../../../../components/csv-import/ui/components/step-suspense/step-suspense';
import { linkIDs } from '../../../../../../services/link-service/links';
import { WorkflowSteps } from '../../../../../../tracking/use-workflow-tracking';

const exampleFile = '/s3/marketplaces/shipstation/CustomPackageImportSample.csv';
const overwriteExistingPackagesProperty = 'shouldOverwriteExisting';

export const ConfigStepBody = () => {
  const intl = useIntl();
  const { form, dispatch, isGetMappingsLoading, isInitImportLoading, trackProcess } = useImportContext();
  const { shouldOverwriteExisting } = form as CustomPackageImportForm;

  const handleToggleOverwriteExisting = (checked: boolean) => {
    dispatch({ type: OVERWRITE_EXISTING_PACKAGES, shouldOverwriteExisting: checked });
    trackProcess(WorkflowSteps.CSV_IMPORT_CHANGE_CUSTOM_PROPERTY, {
      property: overwriteExistingPackagesProperty,
      value: checked,
    });
  };

  return (
    <StepSuspense isLoading={isGetMappingsLoading || isInitImportLoading}>
      <StepHeader>
        <FormattedMessage {...messages.uploadFile} />
      </StepHeader>
      <ImportDescription articleId={linkIDs.CreateCustomPackage} file={exampleFile} message={messages.helpContentText} />
      <InitErrors />
      <AddCsvFile name='custom-package-import' />
      <Checkbox
        checked={shouldOverwriteExisting}
        label={intl.formatMessage(messages.overwriteExistingPackages)}
        onChange={handleToggleOverwriteExisting}
      />
      <FlexColumn className={styles['mapping-list-wrapper']}>
        <MappingList />
      </FlexColumn>
    </StepSuspense>
  );
};
